import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth, AdminLayout } from "./AdminLayout";
import { PhotoGalleryManager } from "../../components/admin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AdminGalleries = () => {
  const { token } = useAuth();
  const [galleries, setGalleries] = useState([]);

  useEffect(() => {
    fetchGalleries();
  }, []);

  const fetchGalleries = async () => {
    try {
      const res = await axios.get(`${API}/galleries`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setGalleries(res.data);
    } catch (error) {
      console.error("Error fetching galleries:", error);
    }
  };

  return (
    <AdminLayout>
      <div className="space-y-6" data-testid="admin-galleries">
        <h1 className="heading-3">Photo Galleries</h1>

        <PhotoGalleryManager
          galleries={galleries}
          onRefresh={fetchGalleries}
          token={token}
        />
      </div>
    </AdminLayout>
  );
};

export default AdminGalleries;
